import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "@mantine/form";
import setPassword from "../../API/setPassword";
import {
	AppShell,
	Text,
	useMantineTheme,
	Image,
	Button,
	Group,
	Box,
	Container,
	PasswordInput,
	Loader,
} from "@mantine/core";
import imageIcon from "../../static/svg/ivistlogin.svg";
import Footr from "../../components/Footr";
import { useSelector } from "react-redux";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
import { logoutAction } from "../../services/Action/userAction";
function SetPassword() {
	const [loading, setLoading] = useState(false);
	const UserId = useSelector((state) => state.otpReducer.users.res.UserId);
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const theme = useMantineTheme();
	const form = useForm({
		initialValues: {
			Password: "",
			authTypeId: 1,
			UserId: UserId,
		},
		validate: {
			Password: (value) => (value.length < 8 ? "Max 8 char" : null),
			passConformPasswordword: (value, values) =>
				value !== values.Password ? "Passwords did not match" : null,
		},
	});

	const handleSubmit = form.onSubmit(async (value) => {
		setLoading(true);
		const result = await setPassword(value);
		if (result.status === 200) {
			setLoading(false);
			showSuccessNotification("update Password Successfuly");
			navigator("/login");
			dispatch(logoutAction());
		} else {
			setLoading(false);
			showErrorNotification("Password not set");
		}
	});
	return (
		<AppShell
			styles={{
				main: {
					position: "relative",
					minHeight: "calc(100vh - 48px)",
					maxHeight: "auto",
					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
		>
			<div
				style={{
					background: "#040F1F",
					margin: "auto",
				}}
			>
				<ToastContainer />
				<Container className="signupForm" size="xs" px="xs">
					<Group position="center" align="center">
						<Image src={imageIcon} width={270} pb={30} pt={50} />
					</Group>
					<Text
						style={{ color: "white" }}
						align="center"
						size="xl"
						weight={700}
						pb={20}
					>
						Set New Password
					</Text>
					<Box sx={{ maxWidth: 340 }} mx="auto">
						<form onSubmit={handleSubmit}>
							<PasswordInput
								styles={{
									input: {
										backgroundColor: "#252E3D",
										position: "relative",
									},
									root: {
										width: "100%",
										color: "white",
									},
								}}
								{...form.getInputProps("Password")}
								mt="sm"
								placeholder="Password"
								className="logInpMargin"
								defaultValue="secret"
							/>
							<PasswordInput
								styles={{
									input: {
										backgroundColor: "#252E3D",
										position: "relative",
									},
									root: {
										width: "100%",
										color: "white",
									},
								}}
								{...form.getInputProps(
									"passConformPasswordword"
								)}
								mt="sm"
								placeholder="Conform password"
								className="logInpMargin"
							/>
							<Group position="center" mt="lg">
								<Button
									style={{ width: "340px" }}
									type="submit"
								>
									Set Password
								</Button>
							</Group>
						</form>
					</Box>
				</Container>
			</div>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default SetPassword;
